import React from "react";
import classes from "./WordGameInfoModal.module.css";
import { useTranslation } from "react-i18next";

const WordGameInfoModal = ({ closeModal }) => {
  const {t}=useTranslation();
  return (
    <div className={classes.modal_container}>
      <div className={classes.modal_subcontainer}>
        <h2 className={classes.text_main}>{t("145")}</h2>
        <p className={classes.text_secondary}>{t("146")}</p>
        <ul>
          <li className={classes.text_secondary_2}>
            {t("147")}
          </li>
          <li className={classes.text_secondary_2}>
           {t("148")}
          </li>
        </ul>
        <h3 className={classes.text_main_2}>{t("149")}</h3>
        <ul>
          <li style={{ listStyle: "none" }}>
            <div>
              <div className={classes.word_container}>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  T
                </div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  R
                </div>
                <div className={classes.letter}>I</div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  E
                </div>
                <div className={classes.letter}>D</div>
              </div>
              <strong style={{ color: "black" }}>T R E </strong>
              <span className={classes.span_word}>
                {t("150")}
              </span>
            </div>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div className={classes.letter}>D</div>
              <div className={classes.letter}>Y</div>
            </div>
            <strong style={{ color: "black" }}>R E A </strong>{" "}
            <span className={classes.span_word}>
              {t("150")}
            </span>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
            </div>
            <strong style={{ color: "black" }}>{t("151")} </strong>
            <span className={classes.span_word}>{t("152")}</span>
          </li>
        </ul>
        <div className={classes.btn_container}>
          <button className={classes.close_button} onClick={closeModal}>
            {t("153")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordGameInfoModal;
